<script type="text/jsx">
import { theme } from '../../thems'
import { ThemeProvider } from 'vue-styled-components'

import {
  StyledTextInputContainer,
  StyledTextInputLabel,
  StyledTextInputField,
  StyledTextInput,
  StyledTextInputError
} from './StyledTextInput'

export default {
  name: 'Input',
  props: ['label', 'errorText', 'error', 'value', 'mask', 'masked', 'placeholder'],
  render () {
    const {label, errorText, error, value, placeholder = ''} = this
    return (
      <ThemeProvider theme={ theme }>
        <StyledTextInputContainer>
          <StyledTextInputLabel domPropsInnerHTML={ label } />
          <StyledTextInputField>
            <StyledTextInput
              error={error}
              onInput={(value) => { this.$emit('change-input', value) }}
              value={value}
              placeholder={placeholder}
            />
            { this.error && <StyledTextInputError>{ errorText }</StyledTextInputError> }
          </StyledTextInputField>
        </StyledTextInputContainer>
      </ThemeProvider>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TextInput/TextInput.vue